// extracted by mini-css-extract-plugin
module.exports = {"component":"Error-404_component_yzeB-"};